import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { NetworkService } from '../../shared/services/network.service';

/**
 * Rutas que solo tienen sentido con conexión. Sin red redirige a `/ruta-del-dia`.
 * `/configuracion` queda fuera: permite restablecer la simulación offline.
 */
@Injectable({
  providedIn: 'root'
})
export class SoloOnlineGuard implements CanActivate {
  private readonly network = inject(NetworkService);
  private readonly router = inject(Router);

  /** Rutas accesibles sin conexión (además de ruta-del-dia). */
  private static readonly rutasPermitidasOffline = ['/ruta-del-dia', '/configuracion'];

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.network.isOnline()) {
      return true;
    }
    const path = state.url.split('?')[0] || '';
    if (SoloOnlineGuard.rutasPermitidasOffline.some(r => path === r || path.startsWith(`${r}/`))) {
      return true;
    }
    void this.router.navigate(['/ruta-del-dia'], { replaceUrl: true });
    return false;
  }
}
